import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import Avatar from '@material-ui/core/Avatar';
import {isDesktop, isMobile} from 'react-device-detect';
import {useDispatch, useSelector} from 'react-redux';
import {selectDeeplinkQR, selectDeeplinkUrl, selectToken} from '../auth/authSlice';
import {selectUserInfo, sendLogoutRequest} from '../login/loginSlice';
import DrawerNav from '../../UI/DrawerNav';
import Navigation from '../../UI/Navigation';
import {desktopWidth, fontSize} from '../../mixins';
import Modal from '../../UI/ModalPopup';
import {makeStyles} from '@material-ui/core/styles';
import SignOut from './SignOut';
import {setShowInvitePopup} from '../invite/inviteSlice';
import {sendLockerStudioData} from '../../analytics/lockerStudio';
import { QrModal } from './DesktopQRCode';

const domainByEnv = process.env.NODE_ENV !== 'production' ? 'test.geodzilla.info' : 'geozilla.com';
const SUBS_URL = `https://subscriptions.${domainByEnv.replace('test.', '')}`;
const LINK_APPSTORE = process.env.REACT_APP_DEEP_LINK_APPLE;
const FAQ_URL = 'https://support.geozilla.com/hc/en-us/';
const SUPPORT_URL = `https://${domainByEnv}/contact/`;
const TERMS_LINK = `https://${domainByEnv}/terms-of-use/`;
const POLICY_LINK = `https://${domainByEnv}/privacy-policy/`;


const StyledMenu = styled.div`
  width: 100px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: auto;
  
  @media screen and (min-width: ${desktopWidth}) {
    width: auto;
    margin-right: 55px;
  }
`;


const StyledName = styled.p`
  margin: 0 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ${fontSize(16)};
  line-height: 21px;
  font-weight: 500;
  letter-spacing: -0.0376471px;
  color: #323232;
`;

const StyledInnerAvatar = styled.div`
  position: absolute;
  top: 8px;
  
      div {
        width: 55px;
        height: 55px;
        margin-left: 24px;
      }
`;


const MenuBlock = () => {
    const dispatch = useDispatch();
    const info = useSelector(selectUserInfo);
    const token = useSelector(selectToken);
    const [modal, setModal] = useState(false);
    const [forceClose, setForceClose] = useState(false);
    const [showQrCodeModal, setShowQrCodeModal] = useState(false);
    const deepLinkUrl = useSelector(selectDeeplinkUrl) || LINK_APPSTORE;
    const deepLinkQR = useSelector(selectDeeplinkQR);

    useEffect(() => {
        if (forceClose) {
            setTimeout(() => setForceClose(false), 1000);
        }
    }, [forceClose]);

    const linksList = {
        subscriptions: `${SUBS_URL}/?token=${token}`,
        faq: FAQ_URL,
        support: SUPPORT_URL,
        terms: TERMS_LINK,
        privacy: POLICY_LINK,
    };
    const sendEvent = (t) => {
        const eventParamName = `tab_${['terms', 'privacy'].includes(t) ? 'redirect' : 'continue'}`;
        sendLockerStudioData(`${t}__click`, { [eventParamName]: '' });
    };
    const openUrl = (type) => {
        sendEvent(type);
        window.location.href = linksList[type];
    };
    const onMobileAppClick = () => {
        sendEvent('mobile_app');
        if (isDesktop && deepLinkQR) {
            setShowQrCodeModal(true);
        } else {
            window.open(deepLinkUrl, '_blank');
        }
        setForceClose(true);
    };
    const onLogoutClick = () => {
        sendEvent('sign_out');
        setModal(!modal);
        setForceClose(true);
    };
    const onInviteClick = () => {
        sendEvent('invite');
        dispatch(setShowInvitePopup(true));
        setForceClose(true);
    };
    const onModalClick = () => dispatch(sendLogoutRequest(token));
    const onCloseClick = () => setModal(!modal);
    const onCloseQrModal = () => {
        setShowQrCodeModal(false);
    };

    const LINKS = [
        {
            name: 'Invite',
            onClick: onInviteClick,
        },
        {
            name: 'Subscriptions',
            onClick: () => openUrl('subscriptions'),
        },
        {
            name: 'Mobile App',
            onClick: onMobileAppClick,
        },
        {
            name: 'FAQ',
            onClick: () => openUrl('faq'),
        },
        {
            name: 'Support',
            onClick: () => openUrl('support'),
        },
        {
            name: 'Terms of Use',
            onClick: () => openUrl('terms'),
        },
        {
            name: 'Privacy Policy',
            onClick: () => openUrl('privacy'),
        },
        {
            name: 'Sign Out',
            onClick: onLogoutClick,
        },
    ];

    const useStyles = makeStyles({
        avatar: {
            border: '1px solid #EBEBEB'
        }
    });

    const classes = useStyles();

    return (
        <StyledMenu>
            <Avatar src={info.photo_url || '../images/default-static-avatar.png'} className={classes.avatar}/>
            {!isMobile && <StyledName>{info.name}</StyledName>}
            <DrawerNav forceClose={forceClose}>
                <StyledInnerAvatar><Avatar src={info.photo_url || '../images/default-static-avatar.png'}/></StyledInnerAvatar>
                <Navigation links={LINKS}/>
            </DrawerNav>
            <Modal show={modal}
                onCloseClick={onCloseClick}
                body={<SignOut/>}
                onActionClick={onModalClick}
                btnText='Sign Out'
                hideCancelOption={false}/>
            <QrModal show={showQrCodeModal} onClose={onCloseQrModal} qrImage={deepLinkQR}/>
        </StyledMenu>
    );
};

export default MenuBlock;